export default __webpack_public_path__ + "static/media/store-electric.718d4110.jpeg";